export const TEMPLATE_ERROR_FAILURE_CODE = 'templateError';
export const TEMPLATE_ERROR_FAILURE_MESSAGE = 'Campaign templates contain errors.';
export const FRONTEND_ERROR_FAILURE_CODE = `frontendError`;
export const FRONTEND_ERROR_FAILURE_MESSAGE = 'Frontend check returned invalid';
